export const ShowingType = {
  recommendations: 0,
  categories: 1,
  questions: 2
};

export const SearchType = {
  hashtags: 0,
  users: 1,
  recommendations: 2
};

export const FriendsType = {
  close_friends: "close_friends",
  friends: "friends",
  acquaintance: "acquaintance"
};

export const ModalViewType = {
  yayscore: "yayscore",
  send_text: "send_text"
};



// WEBPACK FOOTER //
// ./src/helper/type_helper.jsx